export { default as ArrowLink } from '@/assets/svg/arrow-link.svg'
export { default as Attention } from '@/assets/svg/attention.svg'
export { default as Avatar } from '@/assets/svg/avatar.svg'
export { default as Calendar } from '@/assets/svg/calendar.svg'
export { default as Chevron } from '@/assets/svg/chevron.svg'
export { default as Clock } from '@/assets/svg/clock.svg'
export { default as Close } from '@/assets/svg/close.svg'
export { default as CtaPhone } from '@/assets/svg/phone-cta.svg'
export { default as CtaEmail } from '@/assets/svg/mail-cta.svg'
export { default as Company } from '@/assets/svg/company.svg'
export { default as Copy } from '@/assets/svg/copy.svg'
export { default as Download } from '@/assets/svg/download.svg'
export { default as EventDate } from '@/assets/svg/date.svg'
export { default as EventRoute } from '@/assets/svg/route-event.svg'
export { default as Education } from '@/assets/svg/education.svg'
export { default as Envelope } from '@/assets/svg/envelope.svg'
export { default as Experience } from '@/assets/svg/experience.svg'
export { default as Facebook } from '@/assets/svg/facebook.svg'
export { default as FallbackCourse } from '@/assets/svg/fallback-course.svg'
export { default as FocusAreas } from '@/assets/svg/focus-areas.svg'
export { default as Heart } from '@/assets/svg/heart.svg'
export { default as HeartFilled } from '@/assets/svg/heart-filled.svg'
export { default as Info } from '@/assets/svg/info.svg'
export { default as Instagram } from '@/assets/svg/instagram.svg'
export { default as Language } from '@/assets/svg/language.svg'
export { default as Linkedin } from '@/assets/svg/linkedin.svg'
export { default as Link } from '@/assets/svg/link.svg'
export { default as LogoPart } from '@/assets/svg/logo-part.svg'
export { default as LogoFullWhite } from '@/assets/svg/logo-full-white.svg'
export { default as Quote } from '@/assets/svg/quote.svg'
export { default as Signet } from '@/assets/svg/signet.svg'
export { default as ShareArrow } from '@/assets/svg/share-arrow.svg'
export { default as Share } from '@/assets/svg/share.svg'
export { default as UserDetails } from '@/assets/svg/user-details.svg'
export { default as UserLogin } from '@/assets/svg/user.svg'
export { default as Youtube } from '@/assets/svg/youtube.svg'
